module.exports = __webpack_public_path__ + "static/media/07.dc151d8b.png";